// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * @shapeshiftoss/bitcoin-api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { VinScriptSig } from './VinScriptSig';
import {
    VinScriptSigFromJSON,
    VinScriptSigFromJSONTyped,
    VinScriptSigToJSON,
} from './VinScriptSig';

/**
 * Contains info about a transaction input
 * @export
 * @interface Vin
 */
export interface Vin {
    /**
     * 
     * @type {string}
     * @memberof Vin
     */
    txid?: string;
    /**
     * 
     * @type {string}
     * @memberof Vin
     */
    vout?: string;
    /**
     * 
     * @type {number}
     * @memberof Vin
     */
    sequence?: number;
    /**
     * 
     * @type {string}
     * @memberof Vin
     */
    coinbase?: string;
    /**
     * 
     * @type {VinScriptSig}
     * @memberof Vin
     */
    scriptSig?: VinScriptSig;
    /**
     * 
     * @type {Array<string>}
     * @memberof Vin
     */
    addresses?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Vin
     */
    value?: string;
}

/**
 * Check if a given object implements the Vin interface.
 */
export function instanceOfVin(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VinFromJSON(json: any): Vin {
    return VinFromJSONTyped(json, false);
}

export function VinFromJSONTyped(json: any, ignoreDiscriminator: boolean): Vin {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'txid': !exists(json, 'txid') ? undefined : json['txid'],
        'vout': !exists(json, 'vout') ? undefined : json['vout'],
        'sequence': !exists(json, 'sequence') ? undefined : json['sequence'],
        'coinbase': !exists(json, 'coinbase') ? undefined : json['coinbase'],
        'scriptSig': !exists(json, 'scriptSig') ? undefined : VinScriptSigFromJSON(json['scriptSig']),
        'addresses': !exists(json, 'addresses') ? undefined : json['addresses'],
        'value': !exists(json, 'value') ? undefined : json['value'],
    };
}

export function VinToJSON(value?: Vin | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'txid': value.txid,
        'vout': value.vout,
        'sequence': value.sequence,
        'coinbase': value.coinbase,
        'scriptSig': VinScriptSigToJSON(value.scriptSig),
        'addresses': value.addresses,
        'value': value.value,
    };
}

